import { Grid } from "@mui/material";
import { FormSection } from "components/FormControls/FormSection";
import { ItemTypeCheckbox } from "components/FormControls/ItemTypeCheckbox";
import { useMessage } from "hooks/intl";
import { kebabCase } from "lodash";
import { CampaignTriggers, CampaignTriggersUnion } from "types/campaigns";
import { campaignTriggers } from "../../Common/campaignHelpers";

interface Props {
  setFieldValue: (field: string, value: any) => void;
  trigger: CampaignTriggersUnion;
  toggleTriggerStep: (trigger: CampaignTriggersUnion) => void;
}

export const CampaignTrigger = ({
  setFieldValue,
  trigger,
  toggleTriggerStep,
}: Props) => {
  const { message } = useMessage();

  return (
    <FormSection title={message({ id: "campaignTrigger" })}>
      <Grid container spacing={12}>
        {campaignTriggers
          .filter(
            (triggerDetails) =>
              triggerDetails.campaign !== CampaignTriggers.ACHIEVEMENT &&
              triggerDetails.campaign !==
                CampaignTriggers.CUSTOM_EVENT_UNIQUE_CODE,
          )
          .map((triggerDetails) => {
            return (
              <Grid item xs={4} key={triggerDetails.campaign}>
                <ItemTypeCheckbox
                  activeItem={triggerDetails.campaign === trigger}
                  label={message({ id: triggerDetails.label })}
                  description={message({
                    id: triggerDetails.descriptionText,
                  })}
                  onClick={() => {
                    toggleTriggerStep(triggerDetails.campaign);
                    setFieldValue("trigger", triggerDetails.campaign);
                  }}
                  data-test-id={kebabCase(triggerDetails.campaign)}
                />
              </Grid>
            );
          })}
      </Grid>
    </FormSection>
  );
};
